import { Injectable }               from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders}   from "@angular/common/http";
import { AlertController, Platform } from "@ionic/angular";
import { Connectivity }       	    from './connectivity_provider';
import { LocalStorageService}       from './localStorage.service';
import { MessagePresenter }         from "./message.service";
import { Router }                   from '@angular/router';
import { FileOpener }               from '@whiteguru/capacitor-plugin-file-opener';

import { Filesystem, Directory }    from '@capacitor/filesystem';

declare var cordova: any;

export function getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
    return zoneOriginalInstance || fileReader;
}

@Injectable()
export class API {  
    
    ApiURL : string = "https://consulta.vet/api/last/";
    //ApiURL : string = "https://consulta.vet/api/";
    
    AmazonS3Url : string = "https://s3-eu-west-1.amazonaws.com/consultavet2/";

    headers = new HttpHeaders({'Content-Type': 'application/json'});
    headersRaw = new HttpHeaders({'Content-Type': 'text/plain'})
    
    /* nota: solo uso el tema de file para abrir los pdfs de las especialidades
    porque el resto de pdfs, libros, capítulos y artículos se están subiendo a yumpu
    y van embebidos con iframe */

    constructor(public http:HttpClient,
                private router:Router,
                public messagePresenter: MessagePresenter,
                private localStorage: LocalStorageService,
                private Connectivity: Connectivity,
                private alertCtrl: AlertController,
                private platform:Platform
                ) {                   

    }
    
    public EspeciesHabilitadas() {
        let url = this.ApiURL + "especies";
        return this.tokenRequest(url, false);
    }

    public Grupos(especieID) {
        let url = this.ApiURL + "grupos/especie/" + especieID;
        return this.tokenRequest(url, false);
    }

    public Subgrupos(especieID,grupoID,strBusqueda) {
        strBusqueda = this.codifica(strBusqueda);
        let url = this.ApiURL + "subgrupos/especie/" + especieID + "/grupo/" + grupoID + "/strBusqueda/" + strBusqueda ;
        if(strBusqueda=='all') {
            return this.tokenRequest(url, false);
        } else {
            return this.tokenRequest(url,false);
        }
    }

    public SubgruposFast(strBusqueda, especieID) {
        strBusqueda = this.codifica(strBusqueda);
        let url = this.ApiURL + "subgrupos-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda ;
        return this.tokenRequest(url,false);
    }

    public Principios(especieID, especieSexo, subgrupoID) {
        let url = this.ApiURL + "principios/especie/" + especieID + "/sexo/" + especieSexo + "/subgrupo/" + subgrupoID;
        return this.tokenRequest(url, false);
    }

    public Principio(especieID, especieSexo, principioID) {
        let url = this.ApiURL + "principio/especie/" + especieID + "/sexo/" + especieSexo + "/principio/" + principioID;
        return this.tokenRequest(url);
    }

    public PrincipiosFast(strBusqueda, especieID) {
        strBusqueda = this.codifica(strBusqueda);
        let url = this.ApiURL + "principios-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda;
        return this.tokenRequest(url, false);
    }

    public PrincipiosFastSinEspecie(strBusqueda) {
        strBusqueda = this.codifica(strBusqueda);
        let url = this.ApiURL + "principios-fast-sin-especie/strBusqueda/" + strBusqueda;
        return this.tokenRequest(url, false);
    }

    public PrincipiosMonografia(pagina, especieID) {
        let perPage = 80;
        let url = this.ApiURL + "principios-monografia/especie/" + especieID + "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url);
    }

    public PrincipioMonografia(principioID, especieID) {
        let url = this.ApiURL + "principio-monografia/especie/" + especieID + "/principio/" + principioID;
        return this.tokenRequest(url);
    }
    
    public getPrincipioDetalle(principioID,especieID) {
        let url = this.ApiURL + "principio-detalle/id/" + principioID + "/especie/" + especieID;
        return this.tokenRequest(url, false);
    }

    // ESPECIALIDADES
    public EspecialidadesCabecera(datosClinicos, indicacionID, principioID) {
        let url = this.ApiURL + "especialidades-cabecera/especie/" + datosClinicos.EspecieID + "/edad/" + datosClinicos.Edad + "/peso/" + datosClinicos.Peso + "/indicacion/" + indicacionID + "/principio/" + principioID;
        return this.tokenRequest(url, false); 
    }

    public Especialidades(datosClinicos, indicacionID, principioID, casoID) {
        let url = this.ApiURL + "especialidades/especie/" + datosClinicos.EspecieID + "/edad/" + datosClinicos.Edad + "/peso/" + datosClinicos.Peso + "/sexo/" + (datosClinicos.Sexo).charAt(0).toUpperCase()+ datosClinicos.Sexo.slice(1) + "/indicacion/" + indicacionID + "/principio/" + principioID + "/caso/" + casoID;
        if (datosClinicos.Edad==null || datosClinicos.Peso==null) {
            url = this.ApiURL + "especialidades-sin-dosis/especie/" + datosClinicos.EspecieID + "/principio/" + principioID;
        }        
        return this.tokenRequest(url, false);
    }
    

    public Especialidad(idEspecie, idEspecialidad) {
        let url = this.ApiURL + "especialidad/especie/" + idEspecie + "/especialidad/" + idEspecialidad;
        return this.tokenRequest(url);
    }

    public EspecialidadesFast(strBusqueda, especieID) {
        strBusqueda = this.codifica(strBusqueda);
        let url = this.ApiURL + "especialidades-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda;
        return this.tokenRequest(url, false);
    }

    public codifica(strBusqueda) {
        if (strBusqueda) {
            return strBusqueda.replace(/[\])}[{(\/]/g, " ");
        } else {
            return strBusqueda;
        }
        
    }

    public EspecialidadIndicaciones(especieID, principioID) {
        let url = this.ApiURL + "especialidad-indicaciones/especie/" + especieID + "/principio/" + principioID;
        return this.tokenRequest(url);
    }

    public EspecialidadesListado(pagina) {
        let perpage = 25;
        let url = this.ApiURL + "especialidades-listado/perpage/" + perpage + "?page=" + pagina;
        return this.tokenRequest(url);
    }

    public getSugerencias() {
        let url = this.ApiURL + "sugerencias";
        return this.tokenRequest(url);
    }

    public getSugerencia(idSugerencia) {
        let url = this.ApiURL + "sugerencia/id/" + idSugerencia;
        return this.tokenRequest(url);
    }

    public delSugerencia(idSugerencia) {
        let url = this.ApiURL + "sugerencia/id/" + idSugerencia;
        return this.tokenDelete(url);
    }
    
    public nuevaSugerencia(datos) {
        let url = this.ApiURL + "sugerencias";
        return this.tokenRequestPost(url, datos);
    }

    public checkInteracciones(principios) {
        let url = this.ApiURL + "check-interacciones";
        return this.tokenRequestPost(url, principios);
    }

    public getNoticiasBadge() {
        let url = this.ApiURL + "noticias-badge";
        return this.tokenRequest(url, false);
    }

    public getSugerenciasBadge() {
        let url = this.ApiURL + "sugerencias-badge";
        return this.tokenRequest(url, false);
    }

    public setUltimaFechaNoticiasVistas() {
        let url = this.ApiURL + "noticias-fecha";
        return this.tokenRequest(url,false);
    }

    public setUltimaFechaSugerenciasVistas() {
        let url = this.ApiURL + "sugerencias-fecha";
        return this.tokenRequest(url,false);
    }
    
    public getTextoLegal(codigo) {
        let url = this.ApiURL + "legal/codigo/" + codigo;
        return this.noTokenRequest(url,false);
    }

    public resultadoHematologia(niveles) {
        let url = this.ApiURL + "hematologia";
        return this.tokenRequestPost(url, niveles);
    }
    
    loginUser(datos:any) {
        let url = this.ApiURL + "login";
        return this.noTokenRequestPost(datos,url,false);   
    }

    loginUserToken(datos:any) {
        let url = this.ApiURL + "login-token";
        return this.noTokenRequestPost(datos, url, false);
    }

    cambiaPassword(oldPassword, newPassword) {
        let datos = { oldPassword: oldPassword, newPassword: newPassword };
        let url = this.ApiURL + "cambia-password";
        return this.tokenRequestPost(url, datos);   
    }

    getToken(datos) {
        let url = this.ApiURL + "token";
        return this.noTokenRequestPost(datos,url,false);   
    }
    
    setCondicionesAceptadas() {
        const url = this.ApiURL + "acepta-condiciones";
        return this.tokenRequest(url, false);
    }

    public Noticias(pagina=1, strBusqueda, especieID) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='')    strBusqueda = 'all';
        let perPage = 5;
        let url = this.ApiURL + "noticias/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url); 
    }

    public NoticiasFast(strBusqueda, especieID, limit= 8) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='')    strBusqueda = 'all';
        let url = this.ApiURL + "noticias-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/limit/" + limit;
        return this.tokenRequest(url, false); 
    }

    public NoticiaDetalle(idNoticia) {
        let url = this.ApiURL + "noticia-detalle/id/" + idNoticia;
        return this.tokenRequest(url); 
    }

    public Articulos(pagina=1, strBusqueda, especieID, loader=true) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='' || strBusqueda=='todos')    strBusqueda = 'all';
        
        let perPage = 15;
        let url = this.ApiURL + "articulos/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url, loader); 
    }
    
    public ArticulosFast(strBusqueda, especieID, limit= 8) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='')    strBusqueda = 'all';
        let url = this.ApiURL + "articulos-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/limit/" + limit;
        return this.tokenRequest(url, false); 
    }

    public ArticuloDetalle(idArticulo) {
        let url = this.ApiURL + "articulo-detalle/id/" + idArticulo;
        return this.tokenRequest(url); 
    }

    public ArticulosIndice() {
        let url = this.ApiURL + "articulos-indice";
        return this.tokenRequest(url, false); 
    }

    public ArticulosSeccionIndice(pagina=1, strBusqueda, especieID) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        let perPage = 15;
        let url = this.ApiURL + "articulos-seccion/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url); 
    }

    public Media(pagina=1, strBusqueda, especieID, loader=true) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='')    strBusqueda = 'all';
        let perPage = 21;
        let url = this.ApiURL + "media/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url, false); 
    }

    public MediaFast(strBusqueda, especieID, limit= 8) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='')    strBusqueda = 'all';
        let url = this.ApiURL + "media-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/limit/" + limit;
        return this.tokenRequest(url, false); 
    }

    public MediaDetalle(idFoto) {
        let url = this.ApiURL + "media-detalle/id/" + idFoto;
        return this.tokenRequest(url); 
    }

    public Videos(pagina=1, strBusqueda, especieID, loader=true) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='')    strBusqueda = 'all';
        let perPage = 15;
        let url = this.ApiURL + "videos/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url, loader); 
    }

    public VideosCantidad(strBusqueda, especieID) {
        strBusqueda = this.codifica(strBusqueda);
        let url = this.ApiURL + "videos-cantidad/especie/" + especieID + "/strBusqueda/" + strBusqueda;
        return this.tokenRequest(url); 
    }

    public VideosFast(strBusqueda, especieID, limit= 8) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='')    strBusqueda = 'all';
        let url = this.ApiURL + "videos-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda + "/limit/" + limit;
        return this.tokenRequest(url, false); 
    }

    public VideoDetalle(idVideo) {
        let url = this.ApiURL + "video-detalle/id/" + idVideo;
        return this.tokenRequest(url); 
    }

    public TutorialDetalle(idVideo) {
        let url = this.ApiURL + "tutorial-detalle/id/" + idVideo;
        return this.tokenRequest(url); 
    }

    public GetIdArticulo(MediaYear, MediaNumero, MediaPagina) {
        let url = this.ApiURL + "articulo-id/year/" + MediaYear + "/numero/" + MediaNumero + "/pagina/" +MediaPagina;
        return this.tokenRequest(url);
    }

    public Indicacion(indicacionID) {
        let url = this.ApiURL + "indicacion/" + indicacionID;
        return this.tokenRequest(url); 
    }

    public Indicaciones(especieID, sistemaID=null, pagina=1) {
        let perPage = 25;
        let url = this.ApiURL + "indicaciones/especie/" + especieID + "/sistema/" + sistemaID +  "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url); 
    }

    public IndicacionesFast(especieID, strBusqueda) {
        strBusqueda = this.codifica(strBusqueda);
        if (strBusqueda=='')    strBusqueda = 'all';
        let url = this.ApiURL + "indicaciones-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda;
        return this.tokenRequest(url, false); 
    }

    public IndicacionesFastDosis(especieID, strBusqueda) {
        if (strBusqueda=='')    strBusqueda = 'all';
        strBusqueda = this.codifica(strBusqueda);
        let url = this.ApiURL + "indicaciones-fast-dosis/especie/" + especieID + "/strBusqueda/" + strBusqueda;
        return this.tokenRequest(url, false); 
    }

    public IndicacionPrincipios(especieID, indicacionID) {
        let url = this.ApiURL + "indicacion-principios/especie/" + especieID + "/indicacion/" + indicacionID;
        return this.tokenRequest(url);
    }

    public Revision(especieID, indicacionID) {
        let url = this.ApiURL + "revision/especie/" + especieID + "/indicacion/" + indicacionID;
        return this.tokenRequest(url, false); 
    }

    public Revisiones(indicacionID) { // deprecated
        let url = this.ApiURL + "revisiones/indicacion/" + indicacionID;
        return this.tokenRequest(url); 
    }

    public getFavoritos(tipo) {
        let url = this.ApiURL + "favoritos/tipo/" + tipo;
        return this.tokenRequest(url);
    }

    public deleteFavorito(id) {
        let url = this.ApiURL + "favoritos/id/" + id;
        return this.tokenDelete(url);
    }

    public addFavorito(tipo, referidoID) {
        let datos = { "tipo": tipo, "referido_id": referidoID, "signo": 1 };
        let url = this.ApiURL + "favoritos";
        return this.tokenRequestPost(url, datos);
    }

    public getFavoritoEspecialidad(idEspecialidad) {
        let url = this.ApiURL + "especialidad-favorito/id/" + idEspecialidad;
        return this.tokenRequest(url);
    }

    public ocultaEspecialidad(tipo, referidoID) {
        let datos = { "tipo": tipo, "referido_id": referidoID, "signo": 0 };
        let url = this.ApiURL + "favoritos";
        return this.tokenRequestPost(url, datos);
    }

    public getLibros() {
        let url = this.ApiURL + "libros";
        return this.tokenRequest(url);
    }

    public getLibro(idLibro) {
        let url = this.ApiURL + "libro/" + idLibro;
        return this.tokenRequest(url);
    }

    public getRevistas(pagina=1) {
        let url = this.ApiURL + "revistas?page=" + pagina;
        return this.tokenRequest(url);
    }

    public getRevista(idRevista) {
        let url = this.ApiURL + "revista/" + idRevista;
        return this.tokenRequest(url);
    }
    
    public getUltimaRevista() {
        let url = this.ApiURL + "ultima-revista";
        return this.tokenRequest(url);
    }

    public getCapitulos(idLibro) {
        let url = this.ApiURL + "capitulos/libro/" + idLibro;
        return this.tokenRequest(url);
    }
    
    public getAbreviaturas() {
        let url = this.ApiURL + "abreviaturas";
        return this.tokenRequest(url);
    }

    public getCientificos() {
        let url = this.ApiURL + "cientificos";
        return this.tokenRequest(url);
    }

    public getDatosAutor(idAutor) {
        let url = this.ApiURL + "cientifico/id/" + idAutor;
        return this.tokenRequest(url);
    }

    public getRevisionesAutor(idCientifico) {
        let url = this.ApiURL + "cientificos-revisiones/cientifico/" + idCientifico;
        return this.tokenRequest(url);
    }

    public getMonografiasAutor(idCientifico) {
        let url = this.ApiURL + "cientificos-monografias/cientifico/" + idCientifico;
        return this.tokenRequest(url);
    }

    public getVideosAutor(idCientifico) {
        let url = this.ApiURL + "cientificos-videos/cientifico/" + idCientifico;
        return this.tokenRequest(url);
    }
   
    public getCasos(pagina=1) {
        let perPage = 15;
        let url = this.ApiURL + "casos" + "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url);
    }

    public addCaso(datos:any) {
        let url = this.ApiURL + "casos";
        return this.tokenRequestPost(url, datos);
    }

    public casoGuardaDieta(datos) {
        let url = this.ApiURL + "casos/dieta";
        return this.tokenRequestPost(url, datos);
    }

    public casoGuardaAnalisis(datos) {
        let url = this.ApiURL + "casos/analisis";
        return this.tokenRequestPost(url, datos);
    }

    public casoGuardaEspecialidad(datos) {
        let url = this.ApiURL + "casos/especialidad";
        return this.tokenRequestPost(url, datos);
    }

    public casoActualizaEspecialidad(datos) {
        let url = this.ApiURL + "casos/especialidad";
        return this.tokenRequestPut(url, datos);
    }

    public getDietasCaso(idCaso) {
        let url = this.ApiURL + "casos/dietas/caso/" + idCaso;
        return this.tokenRequest(url);
    }

    public getAnalisisCaso(idCaso) {
        let url = this.ApiURL + "casos/analisis/caso/" + idCaso;
        return this.tokenRequest(url);
    }

    public getDietaCasoDetalle(idDieta) {
        let url = this.ApiURL + "casos/dieta/" + idDieta;
        return this.tokenRequest(url);
    }

    public getAnalisisCasoDetalle(idAnalisis) {
        let url = this.ApiURL + "casos/analisis/" + idAnalisis;
        return this.tokenRequest(url);
    }

    public getEspecialidadesCaso(idCaso) {
        let url = this.ApiURL + "casos/especialidades/caso/" + idCaso;
        return this.tokenRequest(url);
    }

    public deleteCaso(id) {
        let url = this.ApiURL + "casos/id/" + id;
        return this.tokenDelete(url);
    }

    public deleteEspecialidadCaso(idEspecialidad, idCaso) {
        let url = this.ApiURL + "casos/especialidad/" + idEspecialidad + "/caso/" + idCaso;
        return this.tokenDelete(url);
    }

    public deleteDietaCaso(idDieta, idCaso) {
        let url = this.ApiURL + "casos/dieta/" + idDieta + "/caso/" + idCaso;
        return this.tokenDelete(url);
    }

    public deleteAnalisisCaso(idAnalisis, idCaso) {
        let url = this.ApiURL + "casos/analisis/" + idAnalisis + "/caso/" + idCaso;
        return this.tokenDelete(url);
    }

    public updateCaso(datos) {
        let url = this.ApiURL + "casos";
        return this.tokenRequestPut(url, datos);
    }

    public datosEspecie(especieID) {
        let url = this.ApiURL + "especies/id/" + especieID;
        return this.tokenRequest(url, false);
    }

    public getFavoritosFluidos() {
        let url = this.ApiURL + "favoritos/fluidos";
        return this.tokenRequest(url);
    }

    public getFluidosDisponibles() {
        let url = this.ApiURL + "favoritos/fluidos-disponibles";
        return this.tokenRequest(url, false);
    }

    public GetFluidosElegiblesCalculo() {
        let url = this.ApiURL + "favoritos/fluidos-calculo";
        return this.tokenRequest(url,false);
    }

    public GetFluidosElegiblesMezclas() {
        let url = this.ApiURL + "favoritos/fluidos-mezclas";
        return this.tokenRequest(url,false);
    }

    public GetConcentracionK() {
        let url = this.ApiURL + "fluidos/concentracion-k";
        return this.tokenRequest(url,false);
    }

    public getSistemas() {
        let url = this.ApiURL + "sistemas";
        return this.tokenRequest(url,false);
    }

    public Grafico(graficoID) {
        let url = this.ApiURL + "grafico/" + graficoID;
        return this.tokenRequest(url); 
    }

    public Graficos(especieID, strBusqueda='', pagina=1, loader=true) {
        strBusqueda = this.codifica(strBusqueda);
        if (especieID=='')      especieID = 'all';
        if (strBusqueda=='')    strBusqueda = 'all';
        let perPage = 30;
        let url = this.ApiURL + "graficos/especie/" + especieID + "/strBusqueda/" + strBusqueda +  "/perpage/" + perPage + "?page=" + pagina;
        return this.tokenRequest(url, loader); 
    }

    public GraficosFast(especieID, strBusqueda) {
        strBusqueda = this.codifica(strBusqueda);
        if (strBusqueda=='')    strBusqueda = 'all';
        let url = this.ApiURL + "graficos-fast/especie/" + especieID + "/strBusqueda/" + strBusqueda;
        return this.tokenRequest(url, false); 
    }

    public getCategoriasGraficos() {
        let url = this.ApiURL + "graficos-categorias";
        return this.tokenRequest(url,false);
    }

    public getClases() {
        let url = this.ApiURL + "clases";
        return this.tokenRequest(url);
    }

    public setLike(id, tipo, valor, comentario=null) {
        let datos = { "id": id, "tipo": tipo, "valor": valor, "comentario": comentario };
        let url = this.ApiURL + "likes";
        return this.tokenRequestPost(url, datos);
    }

    public getSecciones() {
        let url = this.ApiURL + "secciones";
        return this.tokenRequest(url);
    }

    public getAwsData () {
        let url = this.ApiURL + "aws";
        return this.noTokenRequest(url, false);
    }

    public actualizaColegiado(datos) {
        let url = this.ApiURL + "colegiado";
        return this.noTokenRequestPost(datos,url);
    }

    public getDispositivos() {
        let url = this.ApiURL + "dispositivos";
        return this.tokenRequest(url, false);
    }

    public dispositivosOk(plataforma, modelo) {
        let url = this.ApiURL + "dispositivos-ok/plataforma/" + encodeURI(plataforma) + "/modelo/" + encodeURI(modelo);
        return this.tokenRequest(url, false);
    }

    public registraDispositivo(dispositivo) {
        let url = this.ApiURL + "dispositivo-registra";
        return this.tokenRequestPost(url, dispositivo);
    }

    public eliminaDispositivo(veterinarioId, dispositivoId) {
        let url = this.ApiURL + "dispositivo-elimina/veterinario/" + veterinarioId + "/dispositivo/" + dispositivoId;
        return this.noTokenDelete(url);
    }

    public solicitarCodigo(veterinarioId:number) {
        let url = this.ApiURL + "solicitar-codigo/veterinario/" + veterinarioId;
        return this.noTokenRequest(url);
    }

    public getTutoriales() {
        let url = this.ApiURL + "tutoriales";
        return this.tokenRequest(url);
    }

    public getTutorial(idTutorial) {
        let url = this.ApiURL + "tutorial/id/" + idTutorial;
        return this.tokenRequest(url);
    }
    
    public Extractos(pagina=1, strBusqueda, especieID, loader=true) {
            strBusqueda = this.codifica(strBusqueda);
            if (strBusqueda=='' || strBusqueda=='todos' || strBusqueda =='null')    strBusqueda = 'all';
            
            let perPage = 15;
            let url = this.ApiURL + "extractos/strBusqueda/" + strBusqueda + "/especie/" + especieID + "/perpage/" + perPage + "?page=" + pagina;
            return this.tokenRequest(url, loader); 
    }

    public getExtracto(idExtracto) {
        let url = this.ApiURL + "extracto/id/" + idExtracto;
        return this.tokenRequest(url);
    }

    public webAppSession(sid) {
        let url = this.ApiURL + "webAppSession/sid/" + sid;
        return this.tokenRequest(url);
    }

    public getConfiguraciones() {
        let url = this.ApiURL + "configuraciones";
        return this.noTokenRequest(url, false);
    }

    noTokenRequest(path: string, loader: boolean = true): Promise<any> {
        if (loader) this.messagePresenter.presentLoadingCustom('crescent', '', 5000);
        if (this.Connectivity.isOnline()) {
            
            return this.http.get(path, { headers: this.headers })
                .toPromise()
                .then(response => {
                    //if (loader) this.messagePresenter.dismissLoadingCustom();
                    return response;
                })
                .catch(error => {
                    //if (loader) this.messagePresenter.dismissLoadingCustom();
                    return Promise.reject(error);
                });
        } else {
            
            this.messagePresenter.presentToast('Sin conexión',2000,"bottom")
            //this.messagePresenter.dismissLoadingCustom();
            return Promise.reject({Error: "noconn"});
        }
    }

    noTokenRequestPost(datos: any, path: string, loader:boolean=true): Promise<any> {
        if (loader) this.messagePresenter.presentLoadingCustom('crescent', '', 5000);
        if (this.Connectivity.isOnline()) {
            return this.http.post(path, datos, { headers: this.headers })
                .toPromise()
                .then(response => {
                    //if (loader) this.messagePresenter.dismissLoadingCustom();
                    return response;
                })
                .catch(error => {
                    //if (loader) this.messagePresenter.dismissLoadingCustom();
                    return Promise.reject(error);
                });
        } else {
            this.messagePresenter.presentToast('Sin conexión',2000,"bottom")
            //this.messagePresenter.dismissLoadingCustom();
            return Promise.reject({Error: "noconn"});
        }
    }

    tokenRequest(path: string, loader:boolean=true): Promise<any> {
        if (loader) this.messagePresenter.presentLoadingCustom('crescent', '', 100);
        return this.localStorage.getToken().then(token => {
        
        if (this.Connectivity.isOnline()) {
            if (token) {
            let headersAuth = new HttpHeaders({
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token
                });

            return this.http.get(path, {headers: headersAuth})
                .toPromise()
                .then(response => {
                    return response;
                })
                .catch(error => {
                    if(error.status=='401') {
                        
                        this.goToLogin();
                    }
                });
            } else {
                this.goToLogin();
            }
        } else {
            this.messagePresenter.presentToast('Sin conexión',2000,"bottom")
            //this.messagePresenter.dismissLoadingCustom();
            return Promise.reject({Error: "noconn"});
        }
        })
    }

    tokenDelete(path: string, loader:boolean=true): Promise<any> {
        if (loader) this.messagePresenter.presentLoadingCustom('crescent', '', 100);
        return this.localStorage.getToken().then(token => {
        if (this.Connectivity.isOnline()) {
            if (token) {
            let headersAuth = new HttpHeaders({
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token
                });

            return this.http.delete(path, {headers: headersAuth})
                .toPromise()
                .then(response => {
                return response;
                })
                .catch(error => {
                    if(error.status=='401') this.goToLogin();
                });
            }else{
                this.goToLogin();
            }
        } else {
            this.messagePresenter.presentToast('Sin conexión',2000,"bottom")
            //this.messagePresenter.dismissLoadingCustom();
            return Promise.reject({Error: "noconn"});
        }
        })
    }

    noTokenDelete(path: string, loader:boolean=true): Promise<any> {
        if (loader) this.messagePresenter.presentLoadingCustom('crescent', '', 100);
        if (this.Connectivity.isOnline()) {
            return this.http.delete(path)
                .toPromise()
                .then(response => {
                return response;
                })
                .catch(error => {
                
                });
        } else {
            this.messagePresenter.presentToast('Sin conexión',2000,"bottom")
            //this.messagePresenter.dismissLoadingCustom();
            return Promise.reject({Error: "noconn"});
        }
    }

    tokenRequestPost(path: string, body: any): Promise<any> {
        return this.localStorage.getToken().then(token => {
            
        if (this.Connectivity.isOnline()) {
            if (token) {
            let headersAuth = new HttpHeaders({
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token
                });

            return this.http.post(path, body, {headers: headersAuth})
                .toPromise()
                .then(response => {
                return response;
                })
                .catch(error => {
                    if(error.status=='401') this.goToLogin();
                });
            }else{
                this.goToLogin();
            }
        } else {
            this.messagePresenter.presentToast('Sin conexión',2000,"bottom")
            //this.messagePresenter.dismissLoadingCustom();
            return Promise.reject({Error: "noconn"});
        }
        })
    }

    tokenRequestPut(path: string, body: any): Promise<any> {
        return this.localStorage.getToken().then(token => {
        if (this.Connectivity.isOnline()) {
            if (token) {
            let headersAuth = new HttpHeaders({
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token
                });

            return this.http.put(path, body, {headers: headersAuth})
                .toPromise()
                .then(response => {
                return response;
                })
                .catch(error => {
                    if(error.status=='401') this.goToLogin();
                });
            }else{
                this.goToLogin();
            }
        } else {
            this.messagePresenter.presentToast('Sin conexión',2000,"bottom")
            //this.messagePresenter.dismissLoadingCustom();
            return Promise.reject({Error: "noconn"});
        }
        })
    }

    private convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject)=> {
        
        try {
            const reader = getFileReader();
            reader.onerror = () => {
                reject;
            }
            reader.onload = () => {
                resolve(reader.result);
            };
            
            reader.readAsDataURL(blob);
        } catch (error) {
            console.log(error);
        }
    });

    // ESTE SUPUESTAMENTE SOLO LO USARÉ PARA ABRIR PDFS DE ESPECIALIDADES
    async openPdf(url: string, title: string, abrirWeb: boolean = false, numero = null, pagina = null) {
        url = this.AmazonS3Url + url;
        let plataforma = null;
        this.localStorage.getDispositivo().then(
            (response) => { 
                plataforma = response.plataforma.toLowerCase();

                if (plataforma=='ios' || plataforma=='android') {
                    this.messagePresenter.presentLoadingCustom('crescent', '',null);
                    const that = this;        
                    try {
                        
                        this.http.get(url, {
                            responseType: 'blob',
                            reportProgress: true,
                            observe: 'events'
                        }).subscribe(async event => {
                            if (event.type === HttpEventType.DownloadProgress) {
                                
                            } else if (event.type === HttpEventType.Response) {
                                
                                const name = url.substr(url.lastIndexOf('/')+ 1);
                                const base64 = await this.convertBlobToBase64(event.body) as string;
                                const filePdf = await Filesystem.writeFile({
                                    path: name,
                                    data: base64,
                                    directory: Directory.Cache
                                });

                                FileOpener.open({
                                    path: filePdf.uri
                                })
                                .then(() => console.log('File is opened'))
                                .catch((e) => {
                                    this.messagePresenter.dismiss();
                                    this.messagePresenter.presentToast("Debe instalar un lector de PDF", 2000, "top");
                                    console.log('Error opening file', e);
                                });

                                that.messagePresenter.dismiss();
                            }
                        });  
                    } catch(e) {
                        that.messagePresenter.dismiss();
                        this.messagePresenter.presentToast("Debe instalar un lector de PDF",2000,"top");
                        console.error('Error en el pdf', e);
                    } 
                    
                } else {
                    if (abrirWeb) {
                        let url = "https://www.consultavet.org/articulo-app-" + numero + "-" + pagina;
                        this.abrirPaginaConsultaOrg(url);
                    } else {
                        // aqui solo en el caso de que sea un articulo de tipo capitulo y no tenga version_html
                        this.messagePresenter.presentToast("Pdf no disponible en web", 8, "bottom");
                    }
                }
            }
        )
    }

    abrirPaginaConsultaOrg(url) {
        
        let f = document.createElement("form");
        
        let token     = document.createElement("input");
        token.type    = "hidden";
        token.name    = "token";
        token.value     = "VcffXTa8JVuv1OuvN2ynOa2yEGDnU0UYvrIIi1WTIPWZlyexzmEqMU0Y1fpeGfUedylw2R695rzLUXb1DFu9K8gtISNWDnR8NuEw";
        f.appendChild(token);
        
        f.method = 'POST';
        f.target = "_system";
        f.action = url;
        document.body.appendChild(f);
        f.submit();
               
    }

    async abrirPaginaConsultaOrgDevice(urlWeb) {        
        const pageContent = '<html><head></head><body><form id="formulario" action="' + urlWeb + '" method="post">' +
        '<input type="hidden" name="token" value="VcffXTa8JVuv1OuvN2ynOa2yEGDnU0UYvrIIi1WTIPWZlyexzmEqMU0Y1fpeGfUedylw2R695rzLUXb1DFu9K8gtISNWDnR8NuEw">' +
        '</form> <script type="text/javascript">document.getElementById("formulario").submit();</script></body></html>';
        const pageContentUrl = 'data:text/html;base64,' + btoa(pageContent);
        
        if (this.platform.is('ios')) {            
            cordova.InAppBrowser.open(pageContentUrl, '_blank', 'location=no,closebuttoncaption=cerrar,footer=yes,zoom=no,closebuttoncolor=#efefef,toolbarposition=top,hidespinner=yes');
        } else {
            cordova.InAppBrowser.open(pageContentUrl, '_blank', 'location=no,closebuttoncaption=cerrar,footer=no,zoom=no,hidespinner=yes');
        }

    }
      
    // DEPRECATED
    /*
    async newOpenPdf(urlWeb: string = null, urlPdf: string = null) {
        urlPdf = this.AmazonS3Url + urlPdf;
        let plataforma = null;
        this.localStorage.getDispositivo().then(
            (response) => { 
                plataforma = response.plataforma.toLowerCase();

                if (plataforma=='ios' || plataforma=='android') {
                    this.messagePresenter.presentLoadingCustom('crescent', '',null);
                    const that = this;        
                    try {
                        
                        this.http.get(urlPdf, {
                            responseType: 'blob',
                            reportProgress: true,
                            observe: 'events'
                        }).subscribe(async event => {
                            if (event.type === HttpEventType.DownloadProgress) {
                                
                            } else if (event.type === HttpEventType.Response) {
                                
                                const name = urlPdf.substr(urlPdf.lastIndexOf('/')+ 1);
                                const base64 = await this.convertBlobToBase64(event.body) as string;
                                const filePdf = await Filesystem.writeFile({
                                    path: name,
                                    data: base64,
                                    directory: Directory.Cache
                                });

                                this.fileOpener.open(filePdf.uri, 'application/pdf')
                                .then(() => console.log('File is opened'))
                                .catch(e => {
                                    that.messagePresenter.dismiss();
                                    this.messagePresenter.presentToast("Debe instalar un lector de PDF",2000,"top");
                                    console.log('Error opening file', e);
                                });

                                that.messagePresenter.dismiss();
                            }
                        });   
                    } catch(e) {
                        that.messagePresenter.dismiss();
                        this.messagePresenter.presentToast("Debe instalar un lector de PDF",2000,"top");
                        console.error('Error en el pdf', e);
                    }
                } else {
                    if (urlWeb) {
                        this.abrirPaginaConsultaOrg(urlWeb);
                    } else {
                        this.messagePresenter.presentToast("Pdf no disponible en web", 8, "bottom");
                    }
                }
            }
        )
    }

    openPdfPrimeroCheck(url, title) {
        this.Connectivity.checkWifiConnection().then(
            (response) => {
                if (response!="WiFi connection") {
                    this.confirmarDownloadSinWifi(url, title);
                } else {
                    //this.openPdf(url, title);
                }
            }
        );
    }

    async confirmarDownloadSinWifi(url, title) {
        let alert = await this.alertCtrl.create({
            header: 'No hay conexión Wifi',
            message: '¿Descargar PDF igualmente?',
            buttons: [
            {
                text: 'Cancelar',
                role: 'cancelar',
                handler: () => {
                
                }
            },
            {
                text: 'Descargar',
                handler: () => {
                //this.openPdf(url,title);
                }
            }
            ]
        });
        await alert.present();
    }
    */

    goToLogin() {
        this.localStorage.clearKeys().then(() => {
            this.messagePresenter.presentToast('Inicie sesión',3000, 'bottom');
            
            this.router.navigateByUrl('/login');
        })
    }


    
}